import { render } from "./SystemNotification.vue?vue&type=template&id=70026cdf&scoped=true"
import script from "./SystemNotification.vue?vue&type=script&lang=js"
export * from "./SystemNotification.vue?vue&type=script&lang=js"

import "./SystemNotification.vue?vue&type=style&index=0&id=70026cdf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70026cdf"]])

export default __exports__